export default {
  TIM_JOIN_GROUP_SUCCESS: 'onTimJoinGroupSuccess',
  TIM_JOIN_GROUP_FAILED: 'onTimJoinGroupFailed',
  TIM_INIT_FAILED: 'onTimInitFailed',
  TIM_KICKED_OUT: 'onTimKickedOut',
  TIM_NET_STATE_CHANGE: 'onTimNetStateChange'
};
